import { Box, Button } from '@mui/material'
import React, { useState } from 'react'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { pairedFilesAtom } from './atoms'
import { useGetAllMissingSourceFiles, useMissingUrls } from './hooks'
import { Table } from 'shared/ui/Table/Table'
import { useTableColumns } from './tableUtility'
import { useSortableList } from '../../api/list.hooks'
import { InfoDisplay } from '../../components/utility/Containers'
import { NewTreesTable } from '../../components/ingestion/NewTreesTable'

export function Ingest() {
  const sourceFiles = useAtomValue(pairedFilesAtom)
  const { columns, colValMap } = useTableColumns()
  const sorted = useSortableList(sourceFiles, { valueMap: colValMap })
  return (
    <Box>
      <Box>
        <strong>IM 360: {sourceFiles.length}</strong>
        <ParseAll />
      </Box>
      <ExplanationData />
      <Box padding="10px">
        <Box>
          <Table items={sorted} columns={columns} />
        </Box>
      </Box>
      <NewTreesTable />
    </Box>
  )
}

function ParseAll() {
  const [downloading, setDownloading] = useState(false)
  const downloadMissing = useGetAllMissingSourceFiles()
  const missingUrls = useMissingUrls()
  const downloadAll = () => {
    setDownloading(true)
    return downloadMissing()
  }

  if (!missingUrls.length) {
    return null
  }
  return (
    <Button disabled={downloading} onClick={downloadAll}>
      Check All
    </Button>
  )
}

function ExplanationData() {
  return (
    <InfoDisplay>
      The Check All button above will download all source files and parse them.
      It will not create any preview trees or any Kiddom trees. This is a way to
      test parsing on all files, or for checking release status for all. There's
      no harm in pressing this button but it will lock up the UI for a while.
      <Box paddingTop="10px">To create a new IM360 tree from export:</Box>
      <ul>
        <li>
          The api export JSON file must be uploaded to our S3
          <ul>
            <li>
              If the file is not found in the list below you need to run the
              python script on a local machine to pull it and then upload to our
              S3
            </li>
            <li>
              Check the Last Modified date, if it is older than what you need
              from the IM360 api you need to re-run the python script and upload
              to our S3
            </li>
          </ul>
        </li>
        <li>
          When you have a recent enough source file you can create a preview
          file from it
          <ul>
            <li>
              Check the Preview Link, it will indicate how long ago the preview
              file was created. If there are TKat changes that are needed since
              the preview file was created create a new preview file
            </li>
            <li>Press the Update Preview button to update the preview.</li>
            <li>
              When a preview file is created it will overwrite the previous
              preview file if it exists.
            </li>
          </ul>
        </li>
        <li>
          When you have a recent enough preview file you can create a Kiddom
          tree from it by pressing the Create Tree button.
          <ul>
            <li>
              The Released value will indicate if IM360 has marked this export
              as ready for release, it will have a green checkmark if released,
              X otherwise.
            </li>
            <li>
              When a tree is created an entry will appear in the table below.
            </li>
            <li>You can open the tree in a new tab by clicking the link.</li>
            <li>
              Pressing the Export Links button will download a csv of the trees
              in this table with the links.
            </li>
          </ul>
        </li>
      </ul>
    </InfoDisplay>
  )
}
